angular.module('impactx.search').controller('SearchListManufacturerCtrl', SearchListManufacturerController);

SearchListManufacturerController.$inject = ['$scope', 'dataGen'];

function SearchListManufacturerController ($scope, dataGen) {
    var ctrl = this;

    this.showSearch = true;

    this.toggleSearch = function()
    {
        ctrl.showSearch = !ctrl.showSearch;
    };

    this.search = function () {
        dataGen.getData($scope, {searchFilter: ctrl.searchFilter}, "/search/manufacturers");
    };

    dataGen.getData($scope, {}, "/search/filtersmall").then(function(data)
    {
        ctrl.searchFilter = data.data;
        ctrl.search();
    });

    $scope.hasManufacturer = function () {
        var result = false;
        if ($scope.data)
        {
            var searchResult = $scope.data.searchResults;
            if (searchResult)
            {
                result = searchResult.numOfManufacturers > 0
            }
        }
        return result;
    };

    this.reset = function () {
        ctrl.searchFilter.searchInput.value = '';
        ctrl.search();
    }
}